<template>
  <v-container fluid grid-list-md>
    <v-row row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="pb-0">
            <h2 class="display-1 ml-4">{{ title }}</h2>
            <v-spacer/>
            <v-btn color="accent" class="secondary--text" small @click="save(1)" :loading="loading">Save</v-btn>
            <v-btn color="accent" class="ml-2 secondary--text" small @click="save(2)" :loading="loading">Save and
              continue
            </v-btn>
            <v-btn color="accent" class="ml-2 secondary--text" small @click="save(3)" :loading="loading">Save and add
              new
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-form ref="form" @submit.prevent="save(1)">
                <v-row>
                  <v-col cols="12" sm="2">
                    <v-text-field outlined dense label="Order*" v-model="editingItem.order"
                                  :rules="[rules.required, rules.minInt(1)]" type="number"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-text-field outlined dense label="Name*" v-model="editingItem.name.en"
                                  :rules="[rules.required]"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea outlined dense label="Description"
                                v-model="editingItem.desc.en"></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="accent" class="secondary--text" small @click="save(1)" :loading="loading">Save</v-btn>
            <v-btn color="accent" class="secondary--text" small @click="save(2)" :loading="loading">Save and continue
            </v-btn>
            <v-btn color="accent" class="secondary--text" small @click="save(3)" :loading="loading">Save and add new
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import log from '../log';
import {mapActions} from 'vuex';
import rules from "../utils/rules";
import utils from "@/utils";

export default {
  data() {
    return {
      loading: false,
      editingItem: {
        order: 1,
        name: {en: ''},
        desc: {en: ''},
      },
      rules: {
        ...rules,
      }
    }
  },
  computed: {
    updating() {
      return !!this.editingItem._id
    },
    title() {
      return this.$route.params.id === 'new' ? 'New section' : 'Edit section';
    },
  },
  methods: {
    ...mapActions(['sendSuccess', 'sendError', 'requestConfirm', 'logout', 'load', 'delete', 'get', 'update', 'insert']),
    loadData() {
      this.loading = true;
      let id = this.$route.params.id;
      this.get({collection: 'sections', id}).then((reply) => {
        this.loading = false;
        if (reply.data) {
          if (!reply.data.desc) reply.data.desc = {en: ''};
          this.editingItem = reply.data;
        }
      }).catch((err) => {
        this.loading = false;
        let message = err.message ? err.message : "there was an error while loading data";
        this.sendError({message});
        this.go(-1);
        if (err.statusCode === 401) {
          this.logout();
        }
      })
    },
    async save(afterAction) {
      let updating = this.updating;
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      this.editingItem.order = utils.toInt(this.editingItem.order, 1)

      let saveFn = updating ? this.update : this.insert;

      try {
        let {data} = await saveFn({collection: 'sections', data: this.editingItem});
        this.sendSuccess({message: "Data saved!"});
        this.loading = false;
        switch (afterAction) {
          case 1:
            await this.$router.replace('/sections')
            break
          case 2:
            this.editingItem = data;
            if (this.$route.params.id === 'new') {
              await this.$router.replace(`/sections/${data._id}`);
            }
            break
          case 3:
            this.editingItem = {
              order: 1,
              name: {en: ''},
              desc: {en: ''},
            }
            if (this.$route.params.id !== 'new') {
              await this.$router.replace(`/sections/new`);
            }
            break
        }

      } catch (err) {
        log.d("Save section error:", err);
        this.loading = false;
        let message = err.message ? err.message : "there was an error while saving data";
        this.sendError({message});
        if (err.statusCode === 401) {
          await this.$router.replace("/");
          this.logout();
        }
      }
    }
  },
  mounted() {
    if (this.$route.params.id !== 'new') {
      this.loadData()
    }
  }
}
</script>
